/**
 * Was der Schnitt annimmt, nach Endung -- für die Dateiwahl im Browser.
 * Dieselbe Liste steht in `@schnitt/box` (`ENDUNGEN`), die der Server zum
 * Einordnen nimmt; ein Test in der API hält beide gleich.
 */
export const MEDIEN_ENDUNGEN = {
    video: ['mp4', 'mov', 'm4v', 'avi', 'mkv', 'mts', 'm2ts', 'mxf', 'webm', 'wmv', 'hevc', '3gp'],
    audio: ['mp3', 'wav', 'aac', 'm4a', 'flac', 'ogg', 'oga', 'opus', 'aif', 'aiff', 'aifc', 'caf', 'amr', 'm4b', 'wma'],
    image: ['jpg', 'jpeg', 'png', 'webp', 'gif', 'heic', 'tif', 'tiff'],
};
/**
 * Das `accept` der Dateiwahl. Die Arten allein reichen am iPhone nicht
 * (Sascha, 15. Oktober: „Kann ich auch Audiodateien in mehreren Formaten
 * hinzufügen? Es ist von Apple nicht auswählbar“): die Dateien-App graut
 * aus, was sie nicht sicher unter „audio/*“ einordnet -- eine `.opus` aus
 * WhatsApp etwa. Jede Endung einzeln genannt, nimmt sie alle.
 */
export const DATEIWAHL = [
    'video/*',
    'audio/*',
    'image/*',
    ...[...MEDIEN_ENDUNGEN.video, ...MEDIEN_ENDUNGEN.audio, ...MEDIEN_ENDUNGEN.image].map((e) => `.${e}`),
].join(',');
/** Taugt die Datei dem Namen nach? Für Dateien, deren Art der Browser nicht kennt. */
export function medienArtNachName(name) {
    const endung = /\.([a-z0-9]+)$/i.exec(name)?.[1]?.toLowerCase();
    if (!endung)
        return null;
    for (const art of ['video', 'audio', 'image']) {
        if (MEDIEN_ENDUNGEN[art].includes(endung))
            return art;
    }
    return null;
}
//# sourceMappingURL=medienEndungen.js.map